/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkAssignRequest
 */
export interface BulkAssignRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkAssignRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the BulkAssignRequest interface.
 */
export function instanceOfBulkAssignRequest(value: object): value is BulkAssignRequest {
    if ((!('userId' in (value as Record<string, any>)) && !('user_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['userId'] === undefined && (value as Record<string, any>)['user_id'] === undefined)) return false;
    return true;
}

export function BulkAssignRequestFromJSON(json: any): BulkAssignRequest {
    return BulkAssignRequestFromJSONTyped(json, false);
}

export function BulkAssignRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAssignRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function BulkAssignRequestToJSON(json: any): BulkAssignRequest {
    return BulkAssignRequestToJSONTyped(json, false);
}

export function BulkAssignRequestToJSONTyped(value?: BulkAssignRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

